export default __webpack_public_path__ + "static/media/icon.ffa3a057.svg";